import React from 'react';

function Preview({ html }) {




  return (

    <>
      {


          <div
            style={{
              border: '1px solid #ccc',
              padding: '10px',
              minWidth: '800px',
              backgroundColor: '#f9f9f9',
              overflow: 'auto',
              height: "80vh",

            }}
          >

            <div id="pdf-content"
             dangerouslySetInnerHTML={{ __html: html }}
            >
           
            </div>
          </div>
      }

    </>



  );
}

export default Preview;
